import { LocationInterface } from './location-interface';
import { BusinessHoursInterface } from './business-hours-interface';
import { DiscountPromotionsInterface } from './discount-promotions-interface';
import { SpecialBusinessHourInterface } from './special-business-hour-interface';
import { BookingPauseInterface } from './booking-pause-interface';
import { AgeIntervalInterface } from './age-interval-interface';
import { UnbookableReason } from '../entities/shop';

export enum ShopType {
  physical = 'physical', // regular brick and mortar shop
  shuttle = 'accommodationShopShuttleService', // shuttle bus from accommodation to physical shop and back
  dropOff = 'locationDropOff', // drop off equipment at location, no interaction
  deliveryPhysical = 'accommodationDeliveryPhysical', // delivery from a solid shop in town
  deliveryVirtual = 'accommodationDeliveryVirtual' // delivery from outside
}

export interface ShopListInterface {
  id: string;
  showOnMap?: boolean;
  isMicrosite?: boolean; // is asked for in shop but is not in the json?
  name: string;
  isSensitive?: boolean;
  ageCategories: Array<{
    name: string;
    id: string;
    classNameMale?: string; // no longer in use
    classNameFemale?: string; // no longer in use
  }>;
  isTopShop: boolean;
  isVirtualShop: boolean;
  isDiscountShop: boolean;
  hasGuaranty: boolean;
  hasModelChange: boolean;
  hasDepot: boolean;
  hasFreeChildren: boolean;
  address: string;
  requiredAdultsForFreeChildren: number;
  freeChildrenPerAdults: number;
  childrenFreeUntilAge: number;
  freeChildrenExplanation: string;
  ageIntervals: Array<AgeIntervalInterface>;
  shopSlug: string; // clever-and-sporty
  townName: string; // Sölden
  townId: number; // 71
  townSlug: string; // austria/tyrol/soelden
  townSlugs: {
    [key: string]: string;
  };
  shopType: ShopType;
  location: LocationInterface;
  position: number; // sort number default by server
  defaultProductDefinitionTitle: string;
  defaultProductBasePrice: string;
  defaultProductOnlinePrice: string;
  defaultProductOnlinePriceRaw: number; // that's our (online) price
  defaultProductBasePriceRaw: number; // that's the shop price when going in
  discount: number;
  imagePath: string;
  imagePathBig: string;
  panoramaImage: string | null;
  distance: number;
  properties: Array<string>;
  rawProperties: { [propertyname: string]: { [value: string]: string } | [] };
  additionalImagePaths: Array<string>;
  inTown: boolean;
  phone: string;
  email: string;
  companyId: number;
  companyShortName: string;
  merchantId: number;
  countryCode: string;
  companyLogoSmall: string;
  isFormerSport2000Company: boolean;
  isIntersportCompany: boolean;
  businessHours: Array<BusinessHoursInterface>;
  specialBusinessHours: Array<SpecialBusinessHourInterface>;
  pickupTime: string;
  discountPromotions: DiscountPromotionsInterface | []; // not yet known
  minOnlineTurnoverFormatted: string;
  minOnlineTurnoverRaw: number; // required minimum total amount to continue to checkout.
  minPersonCount: number;
  virtualShopParentId: number;
  virtualShopParentTown: string; // not yet known
  vsEquipmentToLocation: boolean; // shops that offer an assortment of equipment to a customer in their hotels
  vsLocationDropOff: boolean; // shops that deliver equipment to hotels before customer arrives
  seasonTo: string; // YYYY-MM-DD
  seasonFrom: string; // YYYY-MM-DD
  usesAgeIntervalLength: boolean;
  merchantName: string;
  companyName: string;
  isBindingMandatory: boolean;
  min_delay: number;
  min_duration: number;
  max_duration: number;
  booking_pauses: Array<BookingPauseInterface>;
  unbookable_reasons?: Array<UnbookableReason>;
}
